// extracted by mini-css-extract-plugin
module.exports = {"events-container":"NNMD2Wrnhy","eventsContainer":"NNMD2Wrnhy","widget":"_19n6VF9bOS"};
    if(module.hot) {
      // 1597843268817
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  